/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
/**
 * A function that checks if the current pathname is the same as the link. If the pathname is a subpath of the link,
 * it will also return true if the subpath starts at least N levels deep relative to the link.
 *
 * @param pathname - the current pathname to check
 * @param link - the link to compare against
 * @param strictSubpaths - array of paths that should not activate on subpaths
 */
const isPathnameCurrent = (pathname: string, link: string, strictSubpaths: string[] = ['/']): boolean => {
  if (pathname === link) {
    return true
  }

  const isStrict = strictSubpaths.some((path) => pathname.startsWith(path) && pathname !== path && link === path)

  if (isStrict) {
    return false
  }

  const normalisedCurrentPath = pathname.endsWith('/') ? pathname : `${pathname}/`
  const normalisedLinkPath = link.endsWith('/') ? link : `${link}/`

  return normalisedCurrentPath.startsWith(normalisedLinkPath)
}

export { isPathnameCurrent }
